import * as Actions from "store/actions/app/cash_register.actions";
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array";

const initialState = {
  loading_cash_registers_by_year_month: false,
  cash_registers_by_year_month: [],

  loading_cash_register_openings: false,
  cash_register_openings: [],

  saving_cash_register_opening: false,
  saved_cash_register_opening: false,

  saving_cash_register_closing: false,
  saved_cash_register_closing: false,

  loading_cash_register_movements: false,
  cash_register_movements: [],

  loading_cash_register_totals: false,
  cash_register_totals: null,
};

export default function cashRegisterReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_CASH_REGISTERS_BY_YEAR_MONTH: {
      return {
        ...state,
        loading_cash_registers_by_year_month: action.payload.loading ?? state.loading_cash_registers_by_year_month,
        cash_registers_by_year_month: action.payload.data ?? state.cash_registers_by_year_month,
      };
    }
    case Actions.GET_CASH_REGISTER_OPENINGS: {
      return {
        ...state,
        loading_cash_register_openings: action.payload.loading ?? state.loading_cash_register_openings,
        cash_register_openings: action.payload.data ?? state.cash_register_openings,
      };
    }
    case Actions.SAVE_CASH_REGISTER_OPENING: {
      return {
        ...state,
        saving_cash_register_opening: action.payload.saving ?? state.saving_cash_register_opening,
        saved_cash_register_opening: action.payload.saved ?? false,
        cash_registers_by_year_month: action.payload.data
          ? addOrUpdateObjectInArray(state.cash_registers_by_year_month, action.payload.data, "id_apertura_caja", true)
          : state.cash_registers_by_year_month,
      };
    }
    case Actions.SAVE_CASH_REGISTER_CLOSING: {
      return {
        ...state,
        saving_cash_register_closing: action.payload.saving ?? state.saving_cash_register_closing,
        saved_cash_register_closing: action.payload.saved ?? false,
        cash_registers_by_year_month: action.payload.data
          ? addOrUpdateObjectInArray(state.cash_registers_by_year_month, action.payload.data, "id_apertura_caja")
          : state.cash_registers_by_year_month,
      };
    }
    case Actions.GET_CASH_REGISTER_MOVEMENTS: {
      return {
        ...state,
        loading_cash_register_movements: action.payload.loading ?? state.loading_cash_register_movements,
        cash_register_movements: action.payload.data ?? state.cash_register_movements,
      };
    }
    case Actions.GET_CASH_REGISTER_TOTALS: {
      return {
        ...state,
        loading_cash_register_totals: action.payload.loading ?? state.loading_cash_register_totals,
        cash_register_totals: action.payload.data ?? state.cash_register_totals,
      };
    }
    case Actions.RESET_CASH_REGISTER_TOTALS: {
      return {
        ...state,
        cash_register_totals: null,
      };
    }
    default: {
      return state;
    }
  }
}
